import "assets/stylesheets/themes/minimal.scss";
import "legacy/plugins/fontawesome/far";
import "legacy/plugins/fontawesome/fas";
import "legacy/controllers";

import "channels";

import "legacy/plugins/bootstrap/tooltips";
import "legacy/plugins/bootstrap/popovers";
import "legacy/plugins/events";
import "legacy/plugins/iterable";

import { init as initShareButtons } from "legacy/jquery/components/shareButtons";
import initReactApp from "@config/init";

window.addEventListener("react:app:init", () => {
  document.querySelectorAll("[data-react-app]").forEach((el) => {
    el?.classList.remove("loading");
  });
});

document.querySelectorAll("[data-react-app]").forEach((el) => {
  el?.classList.add("loading");
});

document.addEventListener("DOMContentLoaded", () => {
  initShareButtons();
  initReactApp();
});

const pagesAfterReact = ["subscription_payment/new", "comments/new"];

if (pagesAfterReact.some((path) => window.location.pathname.includes(path))) {
  window.history.scrollRestoration = "manual";

  window.addEventListener("popstate", () => {
    window.location.reload();
  });
} else {
  window.history.scrollRestoration = "auto";
}
